export default __webpack_public_path__ + "6addc2988758214dbc8a69885da2e478.svg";